$(function () {
  $(".modal").on("shown.bs.modal", function () {
    $("body").addClass("modal-open");
  });
});
